import React from 'react';
import Banner from '@leafygreen-ui/banner';
import AutoAdvanceInputs from 'js/common/components/AutoAdvanceInputs';

function pastedValueFormatting(pasteData: string) {
  return pasteData
    .trim()
    .split('')
    .filter((v) => v !== '-');
}

interface DeviceAuthInputProps {
  firstName: string;
  lastName: string;
  username: string;
  icon: string;
  onComplete: (string) => void;
  autoAdvanceInputsRef: React.RefObject<AutoAdvanceInputs>;
  error?: unknown;
}

export function DeviceAuthInput({
  firstName,
  lastName,
  username,
  onComplete,
  icon,
  error,
  autoAdvanceInputsRef,
}: DeviceAuthInputProps) {
  if (!username) {
    return null;
  }
  return (
    <>
      <p css={{ fontSize: 13, fontWeight: 400 }}>
        Hi, {firstName} {lastName} ({username})!
        <br />
        <strong>Enter the code that was given to you through the CLI.</strong>
      </p>
      <AutoAdvanceInputs
        inputsType="deviceCode"
        onComplete={onComplete}
        pastedValueFormatting={pastedValueFormatting}
        icon={icon}
        ref={autoAdvanceInputsRef}
      />
      {error && (
        <Banner variant="danger" css={{ marginTop: 16 }}>
          <strong>Code entered is invalid or expired</strong>
          <br />
          Please try another one
        </Banner>
      )}
    </>
  );
}
